import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { RefundableProvider } from "protect-group-pulse-react";

const options = {
    currencyCode: 'USD',
    environment: 'test',
    languageCode: 'en',
    vendorCode: 'ven_local_335e49673f04444098836e7c9ba47550',
    eventDateFormat: 'DD/MM/YYYY', // optional
    containerSize: 'medium', //optional
    useSaleAction: true, // optional, set this to false if you intend to call our sale endpoint manually
}

const root = ReactDOM.createRoot(
    document.getElementById('root')
);

root.render(
    <React.StrictMode>
        <RefundableProvider options={options}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </RefundableProvider>
    </React.StrictMode>
);